import { Observable, throwError } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleError(error: any): Observable<never> {
  let errorMessage: string;

  if (error instanceof Error) {
    // Si el error ya es una instancia de Error
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    // Si el error es una cadena de texto
    errorMessage = error;
  } else if (typeof error === 'object') {
    if ('message' in error) {
      errorMessage = error.message;
    } else {
      // Si el error es un objeto, tratamos de extraer un mensaje
      errorMessage = JSON.stringify(error);
    }
  } else if (typeof error === 'number') {
    errorMessage = JSON.stringify(error);
  } else {
    const data = JSON.stringify(error);
    // Si el error es de otro tipo (null, undefined, etc.)
    errorMessage = `ocurrió un error desconocido. error: ${data}`;
  }

  return throwError(() => new Error(errorMessage));
}
